import * as t from 'io-ts';
import { fromEnum, BWQuerySystem } from '@bayer-int/portletce-shared';
import { isUndefined } from 'lodash-es';

import type { InputBWQueryDefinition } from 'header/types';

import { define, createSpecSettingsInterface } from './_common';

export interface InputBWQuerySettingDefinition extends InputBWQueryDefinition {
    key: 'INPUT_BW_QUERY';
}

const definition: InputBWQuerySettingDefinition = {
    type: 'InputBWQuery',
    key: 'INPUT_BW_QUERY',
    label: 'Dimension BW query',
    systems: Object.values(BWQuerySystem),
    value: {
        queryId: '',
        system: BWQuerySystem.H2R,
    },
    scope: 'designer',
};

const plainQueryIdC = t.string;
const specSettingsInterface = createSpecSettingsInterface(
    definition,
    t.union([
        plainQueryIdC,
        t.type({
            queryId: plainQueryIdC,
            system: fromEnum<BWQuerySystem>(BWQuerySystem),
        }),
        t.null,
    ]),
);

export const codec = specSettingsInterface.input;

export const InputBWQuerySettingDefinition = define({
    key: 'INPUT_BW_QUERY',
    label: 'inputBWQuery',
    definition,
    fromSetting: settings => {
        if (isUndefined(settings.inputBWQuery)) return undefined;

        const value = specSettingsInterface.extractValue(settings.inputBWQuery);

        if (plainQueryIdC.is(value)) {
            return { queryId: value, system: BWQuerySystem.H2R };
        }
        return value;
    },
    createDefinitionWithOpts: (opts = {}) => ({ ...definition, ...opts }),
    createDefinitionFromSpec: settings =>
        specSettingsInterface.createDefinitionWithSettings(settings.inputBWQuery),
});
